import styled from 'styled-components'

export const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`
